<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <info [option]="{ icon: 'info' }">
      La valorisation du portefeuille est de
      <strong>{{ totalAmount() | number: '1.2-2' }} €</strong>.
    </info>

    @if (products.length) {
      <supports-table
        [supports]="supportRepartition"
        [config]="supportsTable"
      ></supports-table>
    }
  </form-wrapper>
  <form-footer
    (prev)="prev()"
    (next)="onSubmit()"
    [disabledSkip]="true"
  ></form-footer>
</form>
